import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

import { finalize } from 'rxjs/operators';
import { LoaderService } from '@services/loader.service';
import { EventDelegatorService } from '@services/event-delegator.service';
import { Observable } from 'rxjs';
import { MenuService } from '@services/menu.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  // TODO clean up this interceptor remove old parts
  reqCount = 0;
  ngxEventBus = [];
  constructor(
    private loader: LoaderService,
    private eventDelegatorService: EventDelegatorService,
    private menuService: MenuService
  ) {
    // angular js spinner event
    this.ngxEventBus.push(
      this.eventDelegatorService.on('new-http-request', (data) => {
        this.loader.show();
        this.reqCount++;
      })
    );
    this.ngxEventBus.push(
      this.eventDelegatorService.on('new-http-response', (data) => {
        setTimeout((_) => {
          this.reqCompletedHandler();
        }, 50);
      })
    );
  }

  // This is to be used only for Angular
  // intercept(req: HttpRequest<any>, next: HttpHandler) {
  //   const spinnerSubscription = this.loader.spinner$.subscribe();
  //   return next.handle(req).pipe(finalize(() => {
  //     return spinnerSubscription.unsubscribe();
  //   }));
  // }

  // Primitive interceptor using Request Counter
  // This is for Hybrid App
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loader.show();
    this.menuService.setReloadInProgressState(true);
    this.reqCount += 1;
    return next.handle(req).pipe(finalize(() => {
      setTimeout((_) => {
        this.reqCompletedHandler();
      }, 50);
    }));
  }

  reqCompletedHandler() {
    if (this.reqCount) this.reqCount -= 1;
    if (this.reqCount < 1) {
      this.loader.hide();
      this.menuService.setReloadInProgressState(false);
    }
  }
}
